import Checkout from "~/components/parking/Checkout"
import Success from "~/components/parking/Success"
import STYLE_CONSTANTS from '~/style/constants'


const PAY = {
  order: 0,
  slug: "pay",
  Component: Checkout,
  // this self is the flow store
  validate: async self => {
    return true
  }
}

const SUCCESS = {
  order: 1,
  slug: "success",
  Component: Success,
  progressBarColor: STYLE_CONSTANTS.colors.primary.green,
  // this self is the flow store
  validate: async self => {
    return true
  }
}

const PAY_STEPS = [PAY, SUCCESS]

export default PAY_STEPS
